// src/context/CalcLeiteContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';

// Cria o contexto
const CalcLeiteContext = createContext();

// Hook customizado para facilitar o uso do contexto
export const useCalcLeite = () => {
  return useContext(CalcLeiteContext);
};

// Provedor de Contexto que vai envolver as telas de cálculo
export const CalcLeiteProvider = ({ children }) => {
  const [dados, setDados] = useState(() => {
    // Tenta carregar os dados salvos do localStorage ao iniciar
    try {
      const savedData = localStorage.getItem('calcLeiteData');
      return savedData ? JSON.parse(savedData) : {};
    } catch (error) {
      console.error("Erro ao carregar dados do localStorage:", error);
      return {};
    }
  });

  // Salva os dados no localStorage sempre que eles mudam
  useEffect(() => {
    try {
      localStorage.setItem('calcLeiteData', JSON.stringify(dados));
    } catch (error) {
      console.error("Erro ao salvar dados no localStorage:", error);
    }
  }, [dados]);

  // Os valores que serão compartilhados com os componentes filhos
  const value = {
    dados,
    setDados,
  };

  return (
    <CalcLeiteContext.Provider value={value}>
      {children}
    </CalcLeiteContext.Provider>
  );
};